import axios from '@/axios/axios2'

// 获取我的商户基础信息
export const fetchBusinessBaseInfo = params =>
  axios.post('/business/getBusinessBaseInfo', params)

// 获取我的商户详情信息
export const fetchBusinessDetails = params =>
  axios.post('/business/getBusinessDetails', params)

// 获取商户转移信息
export const fetchChangepartner = params =>
  axios.post('/business/init_changepartner', params)

// 获取商户手机号
export const fetchBusinessTel = params =>
  axios.post('/business/getBusinessTel', params)
